import React from 'react';

const TickIcon2 = ({ color = '#757575', width = 20, height = 21, ...rest }) => {
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 4.75L4.25 8.25L11.25 0.75"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TickIcon2;
